import { BAFTA_FUND_SLUG, User } from "@ecologi/shared";
import { useRouter } from "next/router";
import { TuftyButton } from "../../Button/TuftyButton";

type Props = {
  isOwnProfile: boolean;
  isBulkParent?: boolean;
  user?: User | null;
};

export const BuyMoreImpactButton = ({ isOwnProfile, isBulkParent }: Props) => {
  const router = useRouter();

  return (
    <TuftyButton
      primary
      extra={{
        style: {
          display: "block",
          margin: "15px auto 0",
        },
      }}
      onClick={(e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
          e.currentTarget.blur();
        }

        if (isOwnProfile && isBulkParent) {
          router.push(`/impact-shop/${BAFTA_FUND_SLUG}`);
          return;
        }
        router.push("/impact-shop");
      }}
      text={isOwnProfile ? "Buy more impact" : "Fund impact"}
    />
  );
};
